/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { QueryService } from '../../services/query.service';

export class DeselectCommand extends MapCommand {

    invoke() {
        const interactions: MapInteractionsService = this.deps['interactions'];
        const queryService: QueryService = this.deps['queryService'];
        queryService.clearSelection();
        interactions.enablePanInteraction();
        this.deactivate$.next();
    }
}
